import { useCashDrawer } from "@/composables/shop/useCashDrawer";
import { defineStore } from "pinia";

export const useCashDrawerStore = defineStore("cashDrawer", () => {
  const {
    fetchAllCashDrawers,
    fetchAllCashDrawerTotals,
    fetchCashDrawerTotalById,
    createCashDrawerTotal,
    updateCashDrawerTotal,
    popCashDrawer,
    testPrinterConnection,
    selectedCashDrawer,
    setSelectedCashDrawer,
    fetchAndSetDefaultCashDrawer,
    init,
    isLoading,
  } = useCashDrawer();

  return {
    fetchAllCashDrawers,
    fetchAllCashDrawerTotals,
    fetchCashDrawerTotalById,
    createCashDrawerTotal,
    updateCashDrawerTotal,
    popCashDrawer,
    testPrinterConnection,
    selectedCashDrawer,
    setSelectedCashDrawer,
    fetchAndSetDefaultCashDrawer,
    init,
    isLoading,
  };
});
